const UserSelectBar = ({ users, selectedUser, handleUserSelect }) => {
  return (
    <select
      id="typeSelect"
      value={selectedUser.id?.toString() ?? null}
      onChange={(e) => handleUserSelect(e.target.value)}
      style={{
        padding: "10px",
        fontSize: "16px",
        color: "#737373",
        width: "300px",
        border: "1px solidrgb(29, 22, 22)",
        borderRadius: "5px",
        cursor: "pointer",
        backgroundColor: "white",
      }}
      className="customSelect"
    >
      <option value="-1">유저를 선택하세요</option>
      {users.map((user) => (
        <option key={user.id} value={user.id}>
          {user.name || user.nickname} ({user.plan})
        </option>
      ))}
    </select>
  );
};

export default UserSelectBar;
